var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8339 14.6265H8.99854C8.72254 14.6265 8.49854 14.4025 8.49854 14.1265C8.49854 13.8505 8.72254 13.6265 8.99854 13.6265H13.8339C14.1099 13.6265 14.3339 13.8505 14.3339 14.1265C14.3339 14.4025 14.1099 14.6265 13.8339 14.6265Z",
    fill: "#3956C7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1367_9689",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 12,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 2.00011H12.7872V14.6265H1.3335V2.00011Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1367_9689)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74035 3.34454L2.46368 11.1945C2.34968 11.3372 2.30768 11.5212 2.34968 11.6979L2.80368 13.6212L4.82968 13.5959C5.02235 13.5939 5.20035 13.5079 5.31835 13.3612C7.46301 10.6779 11.5517 5.56187 11.6677 5.41187C11.777 5.23454 11.8197 4.98387 11.7623 4.74254C11.7037 4.4952 11.5497 4.2852 11.3277 4.1512C11.2803 4.11854 10.157 3.24654 10.1223 3.2192C9.69968 2.88054 9.08301 2.9392 8.74035 3.34454ZM2.40901 14.6265C2.17768 14.6265 1.97635 14.4679 1.92235 14.2419L1.37635 11.9279C1.26368 11.4485 1.37568 10.9539 1.68301 10.5699L7.96301 2.7152C7.96568 2.71254 7.96768 2.7092 7.97035 2.70654C8.65901 1.8832 9.90434 1.76187 10.7443 2.43587C10.7777 2.46187 11.893 3.32854 11.893 3.32854C12.2983 3.56987 12.615 4.0012 12.735 4.51187C12.8543 5.0172 12.7677 5.53854 12.4897 5.9792C12.469 6.01187 12.451 6.03987 6.09901 13.9865C5.79301 14.3679 5.33435 14.5899 4.84168 14.5959L2.41568 14.6265H2.40901Z",
    fill: "#3956C7"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8158 7.78988C10.7091 7.78988 10.6024 7.75588 10.5111 7.68654L6.87644 4.89454C6.65778 4.72654 6.61644 4.41321 6.78444 4.19321C6.95311 3.97454 7.26644 3.93388 7.48578 4.10188L11.1211 6.89321C11.3398 7.06121 11.3811 7.37521 11.2124 7.59454C11.1144 7.72254 10.9658 7.78988 10.8158 7.78988Z",
    fill: "#3956C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/iconEdit.31bd8c0d540d758ead85851f2043d58a.svg";
export { ForwardRef as ReactComponent };